export const FORM_IDS = {
  CREATE: "create-product-category-form",
  EDIT: "edit-product-category-form",
  DELETE: "delete-product-category-form",
};
